// extracted by css-extract-rspack-plugin
export default {"message":"message-cBF9G9"};